import { Jobdesc, jobdescService } from './../../services/jobdesc.service';
import { Instruction, instructionService } from './../../services/instruction.service';
import { Component, OnInit, HostListener, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { Router, ActivatedRoute } from '@angular/router';
import { Abouthibiz, abouthibizService } from 'src/app/services/abouthibiz.service';
import { faFilter, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { SectionService, Category, Duration } from 'src/app/services/section.service';
import { formatDate } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { Check_log_value, endtestService } from 'src/app/services/endtest.service';
import Swal from 'sweetalert2';

declare var $: any;
declare let jQuery: any;
@Component({
  selector: 'app-ttinstructions',
  templateUrl: './ttinstructions.component.html',
  styleUrls: ['./ttinstructions.component.scss']

})
export class TtinstructionsComponent implements OnInit {
  @ViewChild('alert', { static: true }) alert: ElementRef;
  @ViewChild("check") modalCheckbox: TemplateRef<any>;
  category: Category = {
    id: ''
  };
  duration: Duration = {
    set_id: ''
  };
  check_loggedin: Check_log_value = {
    Test_Taker_User_Id: '',
    schedule_id: ''
  }
  Question_Section: any;
  total: number;
  today = new Date();
  todaysDataTime = '';
  length1: number;
  hours: any;
  temp: any;
  temp1: any;
  myTime: any;
  start_button: string;
  category_count: number = 0;
  keypress: boolean;
  checked: any;
  modalRef: any;
  total_duration: any;
  isReload: false;
  elem: any;
  navigationTime = 120000;
  timeOut = 10000;
  intervalId:any;
  userId: string;

  // todaysDataTime: any;
  constructor(
    private route: ActivatedRoute, private router: Router, private Endtest: endtestService, private section: SectionService, private modal: NgbModal) {

    // this.data1();
    // this.data2();
    this.data();
  }

  ngOnInit() {
    this.myTime = null;
    localStorage.removeItem('on_load_counter');
    this.myTime = setTimeout(() => {
      clearInterval(this.intervalId);
      for (var i = 0; i < this.length1; i++) {
        localStorage['targetSection' + this.Question_Section[i].Section_Id] = 1;
      }
      for (var i = 0; i < this.length1; i++) {
        localStorage['section_button' + this.Question_Section[i].Section_Id] = 1;
      }
      this.start_time();
	  if(this.intervalId !== 0 && this.myTime !== 0)
      {
      this.router.navigateByUrl('section');
      }
    }, this.navigationTime);
    this.get_total_duration()
    this.intervalId = setInterval(() =>{
      this.fetchData()
    },this.timeOut);

    jQuery(document).ready(function ($) {
      if(navigator.userAgent.indexOf("Firefox") != -1 )
      {
          Swal.fire({
              // title: 'Success',
              title: 'Alert',
              text: 'This is Fireox',
              icon: 'warning',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then((result) => {
              if (result.isConfirmed) {
              }
            })
        if (window.history && window.history.pushState) {

          $(window).on('popstate', function () {
            var hashLocation = location.hash;
            var hashSplit = hashLocation.split("#!/");
            var hashName = hashSplit[1];

            if (hashName !== '') {
              var hash = window.location.hash;
            }
          });
          window.history.pushState('/', null, './');
        }
    }
    });
  }


  faFilter = faFilter;
  faInfoCircle = faInfoCircle;

  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
  }

  @HostListener('window:popstate', ['$event'])
  onBrowserBackBtnClose(event: Event) {
 	clearTimeout(this.myTime);
    clearInterval(this.intervalId);
    clearInterval( this.timeOut);
    this.myTime = 0;
    clearTimeout(this.navigationTime);
    this.navigationTime = 0;
    this.intervalId = 0;
    this.timeOut = 0;

    event.preventDefault();
    //window.history.forward();
    this.router.navigate(['/'], { replaceUrl: true });
  }
  data() {
    this.category.id = sessionStorage.getItem('id')
    this.section.category(this.category).subscribe(
      (data) => {

        this.Question_Section = data.results;

        this.length1 = this.Question_Section.length
        this.total = 0;

        this.temp = (this.total) / 60;

        this.temp1 = this.temp.toFixed(2);

        return this.Question_Section;
      },
      err => {
        console.error(err);
      }
    );
  }
  onselect() {
    if (this.checked == undefined) {
      let ngbModalOptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false
      };
      this.modalRef = this.modal.open(this.modalCheckbox, ngbModalOptions)
    }


    this.start_time();
    clearTimeout(this.myTime);
    clearInterval(this.intervalId);
    this.myTime = 0;

    this.userId = sessionStorage.getItem('id')
    for (var i = 0; i < this.length1; i++) {
      localStorage['targetSection' + this.Question_Section[i].Section_Id] = 1;
    }
    for (var i = 0; i < this.length1; i++) {
      localStorage['section_button' + this.Question_Section[i].Section_Id] = 1;
    }
    sessionStorage.setItem("section_collection_counter", JSON.stringify(0))
    localStorage.setItem('category_count', JSON.stringify(this.category_count));
    //
    if (this.checked == true) {
      this.router.navigateByUrl('section');
    }

  }

  start_time() {
    var now = moment().format("hh:mm:ss");

    this.start_button = now

    localStorage.setItem('Logon time', this.start_button)

  }

  fetchData() {
	if(this.intervalId !== 0 && this.myTime !== 0)
    {
    this.check_loggedin.Test_Taker_User_Id = sessionStorage.getItem('id')
    this.check_loggedin.schedule_id = sessionStorage.getItem('Schedule_Id');

    this.Endtest.checkisLogged(this.check_loggedin).subscribe(

      data => {
        if (data.results[0].Is_terminated == 'YES') {
          clearInterval(this.intervalId);
          //this.modalCafe.close(this.modalContent)
          this.router.navigateByUrl('final');
        }
      },
      err => {
        //console.error(err);

      }

    );
  }
  }

  get_total_duration() {
    this.duration.set_id = sessionStorage.getItem('Set_Id')
    this.section.duration(this.duration).subscribe(
      (data) => {

        this.total_duration = data.results[0].totalduration

      },
      err => {
        console.error(err);
      }
    );
  }

  showalert() {
    this.keypress = false;
    setTimeout(() => {

      this.alert.nativeElement.classList.remove('show');
    }, 3000);
  }
  closeAlert() {
    this.keypress = false;
    this.alert.nativeElement.classList.remove('show');

  }

}





